export const content = "No, we don't complete disability forms or leave of absence forms for employment. We suggest reaching out to a primary care physician (PCP) for further guidance.\n";
